const selectPreviousChatDebugTurn = (state) => state.chatDebug.previousTurn;
export default selectPreviousChatDebugTurn;
